<template>
  <div>
    <Admins />
  </div>
</template>

<script>
import Admins from "@/components/Admins/index.vue";
export default {
  components: {
    Admins,
  },
};
</script>

<style></style>
